import { basePath } from '../next.config'
import loggingService from './loggingService'

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const getCurrentCart = async (): Promise<Cart> => {
	let response: Response

	try {
		response = await fetch(`${basePath}/api/musicapp/carts/current`, {
			cache: 'no-store',
		})

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return (await response.json()) as Cart
	} catch (error) {
		loggingService('Error retrieving current cart', error, {
			errorType: 'Cart',
			fetchUrl: response?.url ?? `${basePath}/api/musicapp/carts/current`,
			fetchStatus: response?.status ?? 'Network Failed',
		})
	}
}

const buildAddToCartUrl = (trackId: number, userId?: number): string => {
	const params = new URLSearchParams({ trackId: String(trackId) })
	if (userId != null) {
		params.set('userId', String(userId))
	}

	return `${basePath}/api/musicapp/carts/current?${params.toString()}`
}

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
export const addToCart = async (
	trackId: number,
	userId?: number
): Promise<Cart> => {
	let response: Response
	const fetchUrl = buildAddToCartUrl(trackId, userId)

	try {
		response = await fetch(fetchUrl, { method: 'POST' })
		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		return (await response.json()) as Cart
	} catch (error) {
		loggingService('Error adding track to cart', error, {
			errorType: 'Cart',
			fetchUrl: response?.url ?? fetchUrl,
			fetchStatus: response?.status ?? 'Network Failed',
		})
	}
}
